import { IOrganisationIndexCategory } from "../../organisations/model/OrganisationIndexCategory";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { IVisibilityLevel } from "./VisibilityLevel";

export interface TDocumentType {
  id: number;
  code: string;
  name: string;
  description: string;
  valid: boolean;
  organisationIndexCategories?: IOrganisationIndexCategory[];
  type: string;
  visibilityLevels: IVisibilityLevel[];
}

export interface IDocumentType extends TDocumentType {}

const DocumentType = Model((model: TDocumentType): IDocumentType => {
  const _value: TDocumentType = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get code() {
      return _value.code;
    },
    set code(value) {
      _value.code = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get description() {
      return _value.description;
    },
    set description(value) {
      _value.description = value;
    },
    get organisationIndexCategories() {
      return _value.organisationIndexCategories;
    },
    set organisationIndexCategories(value) {
      _value.organisationIndexCategories = value;
    },
    get type() {
      return _value.type;
    },
    set type(value) {
      _value.type = value;
    },
    get visibilityLevels() {
      return _value.visibilityLevels;
    },
    set visibilityLevels(value) {
      _value.visibilityLevels = value;
    }
  };

  return ValidatableObject<IDocumentType>(_model);
});

export default DocumentType;
